import React from "react";

const Vision = () => {
  return (
    <div className="w-full py-6 md:py-[20px] px-4 md:px-[24px] flex items-center justify-center">
      <div className="text-center max-w-full md:max-w-[1290px]">
        <h2
          className="font-normal text-[24px] md:text-[36px] tracking-tight leading-tight md:leading-[64px] mb-1 text-[#DD0101]"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          The Vision:
        </h2>
        <h1
          className="font-bold text-[42px] md:text-[96px] tracking-tight  md:leading-[100%] mb-4 md:mb-8 text-[#222222]"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          A New Home
          <span className="md:hidden" />
          &nbsp;for ALRA TV
        </h1>
        <p
          className="font-normal md:text-[21px] text-center text-[#666666]"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          For years, ALRA TV has been a guiding light for seekers around the
          world — bringing diverse spiritual voices together to explore the
          deeper truths of life, love, and the divine.
        </p>
        <p
          className="font-bold md:text-[21px] pt-6 text-[#666666]"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          Now, we're inviting you, our beloved viewers and supporters, to help
          us take the next step.
        </p>
      </div>
    </div>
  );
};

export default Vision;
